const configuredConsoleURL = import.meta.env.VITE_SPARK_CONSOLE_URL?.trim();
const developmentConsoleURL = import.meta.env.DEV
  ? `${window.location.protocol}//${window.location.hostname}:4174/`
  : '/console/';

/**
 * The website and user console share one production origin. During local
 * development they run on different Vite ports, so keep the destination
 * configurable instead of scattering environment-specific URLs in pages.
 */
export const consoleURL = configuredConsoleURL
  || developmentConsoleURL;

export function resolveApplicationURL(target: string) {
  if (target === '/console' || target === '/console/') return consoleURL;
  if (target.startsWith('/console/#') || target.startsWith('/console/?')) {
    return `${consoleURL.replace(/\/?$/, '/')}${target.slice('/console/'.length)}`;
  }
  return target;
}
